import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {CreepyCarnivalTwoGameMode} from "../../gamemode/CreepyCarnivalTwoGameMode";

export class CCTwoFreeSpinExitEvents {
    public static readonly OUT_OF_FREE_SPIN: string = "CCTwoFreeSpinEntryEvents_OUT_OF_FREE_SPIN";
}

export class CCTwoFreespinOutroController extends FreespinOutroController {
    protected close(): void {
        EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinExitEvents.OUT_OF_FREE_SPIN));
        // If you want to reset the symbols back to the sets winning the freespin and start the individual win presentation,
        // 1. get the symbols from serverData.reelsEnteringFreespin and replace them to the reels.
        // 2. get the win data winning the freespin, send it with event WinPresentationEvent.UPDATE_DISPLAYED_BET_LINE_WINS
        // 3. send event SpinEvent.IDLE to start the individual win.

        super.close();
    }

    protected calculateIsTriggered(data: ParsedServerData): boolean {
        return (data.mode === CreepyCarnivalTwoGameMode.RESPIN_FREESPIN || data.mode === CreepyCarnivalTwoGameMode.FREESPIN) && data.freespinsLeft === 0 && data.nextMode === CreepyCarnivalTwoGameMode.NORMAL;
    }
}

